import { useQuery } from '@tanstack/react-query';
import { UsersService } from '../services';
import { usersKeys } from '../queryKeys';

/**
 * Every GoTu admin, keyed by internal_user row id — the names the Sales Metros
 * page resolves a metro's admins to, and the set its edit dialog offers.
 *
 * `retry: false` so an auth-service outage reaches the page's error state at
 * once rather than after three silent retries.
 */
export const useGetAllInternalUsers = () => {
  const { data, isError, isPending, isFetching } = useQuery({
    queryKey: usersKeys.allInternalUsers(),
    queryFn: () => UsersService.getAllInternalUsers(),
    retry: false,
  });

  return {
    admins: data ?? [],
    isPending,
    isFetching,
    isError,
  };
};
